import { AlertError } from 'vnetwork-ui'
import { Button, Typogaphy } from 'vnetwork-ui'

interface ErrorPageProps {
    status?: number
    error?: Error
}

const ErrorPage = ({ status = 500, error }: ErrorPageProps) => {
    console.error(error)

    return (
        <div className="bg-white p-4 rounded-lg">
            <div className="text-center flex flex-col items-center">
                <Typogaphy className="text-4xl font-semibold">
                    {status}!
                </Typogaphy>

                {error && <AlertError error={error} />}

                <Typogaphy
                    className="text-gray-600 mx-auto max-w-xl mt-4"
                    size="small"
                >
                    We seem to have encountered a small issue in answering your
                    question. Please click the back button and try another
                    question.
                </Typogaphy>
                <Typogaphy
                    size="small"
                    className="text-gray-600 mb-6 mt-2 font-semibold"
                >
                    If you'd like to view the details of the issue,{' '}
                    <a href="#" className="text-blue-400 hover:underline">
                        click here
                    </a>
                    .
                </Typogaphy>

                <div className="flex gap-4">
                    <Button
                        size="small"
                        type="button"
                        color="primary"
                        variant="contained"
                        onClick={() => window.history.back()}
                    >
                        Go Back
                    </Button>

                    <Button
                        size="small"
                        type="button"
                        color="primary"
                        variant="outlined"
                        className="text-bg-primary"
                        onClick={() => window.location.reload()}
                    >
                        Reload
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ErrorPage
